"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing2css = exports.StyledDivider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var spacing2css = function spacing2css(_ref) {
  var s = _ref.spacing;
  return s === "minimal" ? "0 auto" : s === "standard" ? "1rem auto" : "2rem auto";
};
exports.spacing2css = spacing2css;
var StyledDivider = _styledComponents.default.span.withConfig({
  displayName: "style__StyledDivider",
  componentId: "sc-1wtvool-0"
})(["width:100%;position:relative;display:block;overflow:hidden;padding-top:0.4em;max-width:", ";border-color:", ";margin:", ";border-top:1px solid ", ";&:before,&:after{content:\"\";display:block;position:absolute;height:0.4em;width:0.5em;left:0;bottom:100%;background:", ";transform-origin:left bottom;transform:rotate(20deg);}&:after{left:auto;right:0;transform-origin:right bottom;transform:rotate(-20deg);}"], function (_ref2) {
  var variant = _ref2.variant;
  return variant === "long" ? "100%" : "140px";
}, function (props) {
  return props.theme.color_accent;
}, spacing2css, function (props) {
  return props.theme.color_accent;
}, function (props) {
  return props.theme.color_accent;
});
exports.StyledDivider = StyledDivider;